module.exports = __webpack_public_path__ + "static/media/leaderSmallCompanies2020.3210d72d.png";